import { createClient } from '@sanity/client'
import { createImageUrlBuilder } from '@sanity/image-url'

export const sanity = createClient({
  projectId: '8q8ewbp1',
  dataset: 'production',
  apiVersion: '2026-05-28',
  useCdn: false,
})

const builder = createImageUrlBuilder(sanity)

export function urlFor(source) {
  return builder.image(source)
}